import React from 'react';
import './MediaLogos.css';

function MediaLogos() {
  const logos = [
    { 
      id: 1, 
      image: 'media-logo-1.png', 
      alt: 'OK Diario', 
      content: 'media-content-1.jpg',
      text: "Hablamos de cómo Tabia Group lleva la gestión del patrimonio de sus clientes, principales operaciones de interés para Tabia, el comportamiento del sector y la visón internacional de David, en la gestión de activos.",
      link: 'https://okdiario.com/economia/david-pons-27-anos-casi-2-000-millones-bajo-gestion-tabia-group-13493076'
    },
    { 
      id: 2, 
      image: 'media-logo-2.svg', 
      alt: 'Capital',
      content: 'media-content-2.jpg',
      text: 'Aportamos nuestra opinión en Revista Capital sobre la situación de la vivienda tras la aprobación de la Ley de la Vivienda. Propuestas y posibles soluciones.',
      link: 'https://capital.es/economia/inversion-inmobiliaria-y-precio-de-la-vivienda-un-callejon-sin-salida/101459/'
    },
    { 
      id: 3, 
      image: 'media-logo-3.png', 
      alt: 'Intereconomia',
      content: 'media-content-3.jpg',
      text: "Participación en el programa Con I de Inmobiliario, de Radio Intereconomía, de la mano de Elena Fraile. Compartimos la visión de Tabia Group sobre la inversión inmobiliaria en Europa.",
      link: 'https://www.intereconomia.com/programa/con-i-de-inmobiliario/'
    },
    { 
      id: 4, 
      image: 'media-logo-4.jpeg', 
      alt: 'Negocios',
      content: 'media-content-4.jpg',
      text: 'Entrevista en Negocios Televisión de la mano de Eva Villanueva Sánchez. David Pons habla de proyecciones de crecimiento, estimaciones de cifra de negocio y nuevos proyectos.',
      link: 'https://www.linkedin.com/posts/negocios-tv_el-secreto-del-%C3%A9xito-de-la-gesti%C3%B3n-de-patrimonio-activity-7257709190784139264-sVLO/?originalSubdomain=es'
    }
  ];

  return (
    <section className="media-logos-section">
      <div className="container">
        <p className="media-intro-text">
          En Tabia Group tenemos mucho que aportar. Nos complace compartir nuestra experiencia, opinión y visión a través de distintos medios.
        </p>
        <div className="media-logos-grid">
          {logos.map((logo) => (
            <div key={logo.id} className="media-logo-container">
              <div className="media-logo-wrapper">
                <img src={`${process.env.PUBLIC_URL}/${logo.image}`} alt={logo.alt} />
              </div>
              {logo.content && (
                <div className="media-content-wrapper">
                  <img src={`${process.env.PUBLIC_URL}/${logo.content}`} alt={`${logo.alt} content`} />
                  {logo.text && <p className="media-content-text">{logo.text}</p>}
                  {logo.link && (
                    <a href={logo.link} target="_blank" rel="noopener noreferrer" className="media-content-link">
                      Ver noticia completa
                    </a>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MediaLogos;
